if (!customElements.get('return-protection')) {
  customElements.define(
    'return-protection',
    class ReturnProtection extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.message = this.querySelector('.return-protection__message');
        if (!this.checkbox) return;
        this.checkbox.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        this.checkbox.disabled = true;
        this.setMessage('Updating return protection...');

        const variantId = this.dataset.variantId;
        const line = this.dataset.line;
        const request = this.checkbox.checked
          ? fetch(`${routes.cart_add_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({
                id: Number(variantId),
                quantity: 1,
                properties: {
                  _return_protection: 'true'
                }
              })
            })
          : fetch(`${routes.cart_change_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({
                line: Number(line),
                quantity: 0
              })
            });

        request
          .then((response) => {
            if (!response.ok) throw new Error('Unable to update return protection.');
            window.location.reload();
          })
          .catch(() => {
            this.checkbox.checked = !this.checkbox.checked;
            this.checkbox.disabled = false;
            this.setMessage('Return protection could not be updated. Please try again.');
          });
      }

      setMessage(text) {
        if (!this.message) return;
        this.message.hidden = false;
        this.message.textContent = text;
      }
    }
  );
}
